/**
 * action types
 */
export const SUBSCRIPTION_PAYMENT_START = 'SUBSCRIPTION_PAYMENT_START';
export const SUBSCRIPTION_PAYMENT_FAILURE = 'SUBSCRIPTION_PAYMENT_FAILURE';
export const INVOICE_PAYMENT_START = 'INVOICE_PAYMENT_START';
export const INVOICE_REQUEST_START = 'INVOICE_REQUEST_START';
export const INVOICE_REQUEST_FAILURE = 'INVOICE_REQUEST_FAILURE';
